import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';

const ChatMessageWrapper = styled.div``;

const LoadingShimmerWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LoadingShimmer = styled.div<{ opacity: number; time: number }>`
  height: 4px;
  ${({ opacity }) => `opacity: ${opacity};`}

  @keyframes placeHolderShimmer {
    0% {
      background-position: -1280px 0;
    }
    100% {
      background-position: 1280px 0;
    }
  }
  animation: placeHolderShimmer 3s linear infinite forwards;
  animation-delay: ${({ time }) => time}s;

  background: linear-gradient(
    65deg,
    ${colors.proximaGreen20} 12%,
    ${colors.white} 16%,
    ${colors.proximaGreen20} 20%
  );
  background-size: 2000px 100%;

  /* default values */
  border-radius: 8px;
  height: 10px;
  width: 300px;
`;

const ChatThinking = () => (
  <ChatMessageWrapper>
    <Text color="neutral70" variant="body2Medium">
      Generating a response
    </Text>
    <LoadingShimmerWrapper>
      <LoadingShimmer opacity={0.8} time={1} />
      <LoadingShimmer opacity={0.5} time={1.2} />
      <LoadingShimmer opacity={0.3} time={1.4} />
    </LoadingShimmerWrapper>
  </ChatMessageWrapper>
);

export default ChatThinking;
